<style>

h1 {
  font-size: 10px;
  color: black;
}

.logon {
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  /* position: relative;
  overflow: hidden; */
  width: 1500px;
  height: 720px;
  max-width: 100%;
  display: flex;
}

.overlaylongH2 {
  font-size: 40px;
  color: rgb(64,159,255);
  margin-bottom: 50px;
  /* width: 250px; */
}
.overlaylong-Signup {
  width: 750px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgb(64,159,255);
  border-radius: 20px;

}
.overlaylong-Signin {

  width: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}

input {
  background-color: #ececec;
  border: black;
  padding: 12px 15px;
  margin: 10px 0;
  width: 300px;
  border-radius: 5px;
}
.inupbutton{
  background-color: rgb(64,159,255);
  border: none;
  width: 150px;
  height: 40px;
  border-radius: 5px;
  font-size: 15px;
  color: white;
  text-align: center;
  line-height: 40px;
  margin-top: 30px;
  margin-left: 20px;
}
</style>

<template>
    <div class="logon">
      <div class="overlaylong-Signup">
        <img src="@/assets/img_1.png"  style="height: 600px; margin-right: 20px;">
      </div>
        <div class="overlaylong-Signin">
          <h2 class="overlaylongH2">欢 迎 登 录</h2>
          <h5 style="margin-right: 250px;color: rgb(64,159,255)"> 用户名</h5>
          <input type="text" placeholder="请输入用户名" v-model="jobNumber">
          <h5 style="margin-right: 260px;color: rgb(64,159,255)"> 密码</h5>
          <input type="password" placeholder="请输入密码" v-model="idNumber">
          <div>
            <button class="inupbutton" @click="reInput()">重置</button>
            <button class="inupbutton" @click="Login()">登录</button>
          </div>
        </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      jobNumber:null,
      idNumber:null,
    }
  },
  methods: {
    Login() {
      if (this.jobNumber == null) {
        this.$message.error('请输入用户名');
        return;
      }
      if (this.idNumber == null) {
        this.$message.error('请输入密码');
        return;
      }
      this.request.post("/admin/Login", {
        jobNumber: this.jobNumber,
        idNumber: this.idNumber,
      }).then(res => {
        if (res.data && res.data.message) {
          const message = res.data.message;
          console.log(res.data.message);
          if (message === "密码正确，登陆成功" && res.data.token) {
            this.loginSuccess(res.data.token,res.data.name);
            if (res.data.name) {
              const targetPath = `/HomeView`;
              this.$router.push(targetPath);
            } else {
              // 处理用户名未返回的情况
              this.$message.error('用户名未返回，请重试');
            }
          } else if (message === "密码错误，请重试") {
            this.$message.error('密码错误，请重试');
          } else if (message === "未知错误") {
            this.$message.error('用户未注册');
          }
        } else {
          // 处理其他可能的错误情况
          this.$message.error('未知错误');
        }
      }).catch(error => {
        // 处理请求错误
        this.$message.error('登录请求失败');
      });
    },
    loginSuccess(token,name) {
      localStorage.setItem('userToken', token);
      localStorage.setItem('userName', name);
    },
    reInput(){
      this.jobNumber=null
      this.idNumber=null
    }
  }
}
</script>